import { init_datalayer } from '../init.js';
import { push_data_object } from '../../datalayer/gtm/gtm_push.js';
import $ from 'jquery';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'datalayer_site_header';

// ===========================================================================
// datalayer handlers
// ===========================================================================

function addon_handler() {
    const getAbsoluteUrl = url => {
        if (url[0] === '/') {
            url = `${window.location.protocol}://${
                window.location.hostname
            }${url}`;
        }
        return url;
    };

    $('.siteHeader').on(
        'click',
        '[data-track-category],[data-track-action]',
        e => {
            const category = e.currentTarget.getAttribute(
                'data-track-category'
            );
            const action = e.currentTarget.getAttribute('data-track-action');
            const label = getAbsoluteUrl(e.currentTarget.getAttribute('href'));
            const eventDataObj = {
                event: 'Website Events',
                event_category: category,
                event_action: action,
                event_label: label,
            };

            push_data_object(eventDataObj);
        }
    );
}

// ===========================================================================
// Data layer
// ===========================================================================

function init_handlers(global) {
    addon_handler(global);
}

// global is the window object when in the browser context this function should
export function initialize(global) {
    init_datalayer(global, init_handlers, () => {});
}
